import defaultTheme from "./default.json";

const themes = {
  default: defaultTheme,
};

export default themes;
